(function () {
    "use strict";

    angular.module("app").controller("ViewOnlyPersonController", ViewOnlyPersonController);
    ViewOnlyPersonController.$inject = ["$scope", "$window", "personService_Check", "enumService", "controllerDecorator", "codesService", "habilEnabledFeatures"];
    function ViewOnlyPersonController($scope, $window, personService_Check, enumService, controllerDecorator, codesService, habilEnabledFeatures) {
        const vm = this;
        controllerDecorator.Decorate(vm, ["comments"]);

        $scope.request = {};

        $scope.isCurrent = (tab) => personService_Check.currentTab === tab;

        $scope.$on("navigation_change", (_event, tab) => personService_Check.currentTab = tab.key);

        $scope.ExecutivePartners = [];

        vm.Utils.invoke(codesService.getCodePartnersList, p => $scope.ExecutivePartners = p);

        $scope.requestId = $window.location.search.split("=")[1];
        if ($scope.requestId === undefined) {
            $scope.requestId = $window.location.search.split("?")[1];
        }

        $scope.AllScreenings = [];

        $scope.filterRelations = function (item) {
            return item.PersonTypeCode !== '10' &&
                item.PersonTypeCode !== '11' &&
                item.PersonTypeCode !== '20' &&
                item.PersonTypeCode !== '21' &&
                item.PersonTypeCode !== '120' &&
                item.PersonTypeCode !== '121' &&
                item.PersonTypeCode !== '170' &&
                item.PersonTypeCode !== '171' &&
                !item.IsPartner;
        };
        $scope.filterChildren = function (item) {
            return (item.PersonTypeCode === '21' ||
                item.PersonTypeCode === '120' ||
                item.PersonTypeCode === '121') &&
                !item.IsPartner;
        };
        $scope.filterRefs = (item) => item.PersonTypeCode === '170';
        $scope.filterPartners = function (item) {
            return item.IsPartner ||
                item.PersonTypeCode === '10' ||
                item.PersonTypeCode === '11' ||
                item.PersonTypeCode === '20' ||
                item.PersonTypeCode === '171';
        };
        $scope.personsThatNeedToSign = function () {
            if (!$scope.request || !$scope.request.RequestIVMRelatedPersonList) return;
            return $scope.request.RequestIVMRelatedPersonList.filter(function (r) {
                return (r !== null && r.PersonData && r.PersonData.NeedsSigning) ? r : null;
            });
        };

        $scope.AcknowledgePersonRemark = function (parent, item) {
            if (item.PublicId === undefined) {
                const index = parent.Remarks.indexOf(item);
                parent.Remarks.splice(index, 1);
            }
            if (item.Section === '201') {
                item.Section = '204';
                parent.IsIdentificationValidated = false;
            }
            if (item.Section === '202') {
                item.Section = '205';
                parent.IsIdentificationValidated = false;
            }
        };

        function loadRequest() {
            vm.SetLoadingState(true);

            vm.Api.GetIVMRequestPhase5(
                { RequestId: $scope.requestId },
                (result) => {
                    if (CheckResultReceived(result)) {
                        $scope.request = result.data;

                        $scope.AllScreenings = [...$scope.request.Screenings, ...$scope.request.ForeignScreenings];

                        getRemarks();

                        vm.Comments.Initialize({ RequestId: $scope.request.PublicId, DossierId: null, OrganisationId: $scope.request.DossierOrganisationPublicId, ICD: $scope.request.ScreeningBy });
                    }
                    else { vm.ShowError(result); }
                },
                vm.ShowError,
                () => vm.SetLoadingState(false)
            );
        }

        function getRemarks() {
            vm.Api.GetRemarksForPscRequest(
                { RequestId: $scope.request.PublicId },
                (result) => {
                    if (CheckResultReceived(result)) {
                        $scope.otherRemarks = result.data.OtherRemarks;
                    }
                    else {
                        vm.ShowError(result);
                    }
                },
                vm.ShowError
            );
        }

        $scope.GetScreeningReports = getScreeningReports;

        const cache = {
            screeningReports: null
        };

        function getScreeningReports() {
            if (Array.isArray(cache.screeningReports)) {
                return cache.screeningReports;
            }

            if (!$scope.request?.Screenings?.length) {
                return [];
            }

            cache.screeningReports = $scope.request.Screenings.flatMap(s => s.Attachments?.filter(a => a.TypeCode == enumService.AttachmentTypes.ScreeningResultDocument) ?? []);

            return cache.screeningReports;
        }

        function addUnloadEvent() {
            if ($window.addEventListener) {
                $window.addEventListener("beforeunload", handleUnloadEvent);
            } else {
                //For IE browsers
                $window.attachEvent("onbeforeunload", handleUnloadEvent);
            }
        }
        function handleUnloadEvent(event) {
            if ($scope.requestForm.$dirty) {
                event.returnValue = $scope.translations.CloseReloadWarningText;
            }
        }

        addUnloadEvent();

        loadRequest();

        $scope.IsAdviceScreening = isAdviceScreening;
        function isAdviceScreening() {
            if (!$scope.request || !$scope.request.CurrentScreening)
                return;

            if ($scope.request.CurrentScreening.TypeCode == enumService.ScreeningTypeCode.SecurityCheck)
                return $scope.translations.InitialAction_Check;
        }

        $scope.IsPayrollConsultantFeatureEnabled = isPayrollConsultantFeatureEnabled;
        function isPayrollConsultantFeatureEnabled() {
            if (!$scope.request || $scope.request.CreatedByFVM)
                return false;

            const ivmPayrollConsultant = "IVM_PAYROLL_CONSULTANT";
            return habilEnabledFeatures.some(f => f == ivmPayrollConsultant);
        }

        $scope.GetScreeningRowStyle = getScreeningRowStyle;
        function getScreeningRowStyle(screening) {
            const partners = [enumService.ScreeningServices.VSSE, enumService.ScreeningServices.ADIVSGRS];

            if (!partners.includes(screening.DoneBy)) {
                if (screening.TypeCode === enumService.ScreeningTypeCode.CertificateOut) return "bg-Foreign";

                const momentScreeningSendDateLimit = moment(screening.ScreeningSendDate).startOf("day").add(3, "M");
                const today = moment().startOf("day");

                if (today.isSameOrBefore(momentScreeningSendDateLimit)) return "bg-Foreign";
                if (today.isAfter(momentScreeningSendDateLimit)) return "screeningOutOfTimeLimit";
            }

            const screeningState = Number.parseInt(screening.Status);
            if (screeningState >= enumService.ScreeningStatusCode.Completed) return "bg-success";
        }
    }
})();
